<template>
  <div class="hero top" style="background-image: url('/img/cp/alternative.jpg')">

  </div>
  <div class="container coverage-section">
    <h2 class="coverage-title">{{ $t('home.coverage_title') }}</h2>

    <div class="coverage-layout">
      <div class="coverage-main">
        <div class="table-responsive plans-tables">
          <table class="table covering plans-comparison mb-0">
            <colgroup>
              <col class="plans-col-label">
              <col class="plans-col-tier">
              <col class="plans-col-tier">
              <col class="plans-col-tier">
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="plan-left-header">{{ $t('home.plans.coverage_header') }}</th>
                <th
                  v-for="plan in planOptions"
                  :key="plan"
                  scope="col"
                  class="text-center plan-tier"
                  :class="planColClass(plan)"
                >
                  {{ $t(`home.plans.${plan}`) }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(rowKey, index) in planRowKeys"
                :key="rowKey"
                class="plans-coverage-row"
                :class="{ 'plans-section-end': index === planRowKeys.length - 1 }"
              >
                <td>{{ $t(rowKey) }}</td>
                <td
                  v-for="plan in planOptions"
                  :key="`${rowKey}-${plan}`"
                  class="text-center"
                  :class="planColClass(plan)"
                >
                  {{ planAmounts[plan][index] }}
                </td>
              </tr>

              <tr class="plans-spacer-row" aria-hidden="true">
                <td :colspan="planOptions.length + 1"></td>
              </tr>

              <tr class="insured-persons-row plans-footer-row plans-footer-start plans-section-end">
                <td>
                  {{ $t('home.plans.insured_persons_label') }}<br>
                  {{ $t('home.plans.insured_persons_age') }}
                </td>
                <td
                  v-for="plan in planOptions"
                  :key="`insured-${plan}`"
                  class="text-center"
                  :class="planColClass(plan)"
                >
                  {{ insuredTextForPlan(plan) }}
                </td>
              </tr>

              <tr class="plans-spacer-row" aria-hidden="true">
                <td :colspan="planOptions.length + 1"></td>
              </tr>

              <tr class="insured-persons-row plans-footer-row plans-footer-start plans-section-end">
                <td>{{ $t('home.plans.annual_premium') }}</td>
                <td
                  v-for="plan in planOptions"
                  :key="`premium-${plan}`"
                  class="text-center"
                  :class="planColClass(plan)"
                >
                  {{ premiumForPlan(plan) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <aside class="coverage-sidebar">
        <div class="coverage-sidebar-top" :class="{ 'coverage-sidebar-sticky-wrap': isSlovak }">
          <div class="coverage-sidebar-inner">
            <h4 class="coverage-sidebar-title">{{ $t('home.plans.select_scope') }}</h4>
            <div class="plan-selector" role="radiogroup" :aria-label="$t('home.plans.select_scope')">
              <button
                v-for="plan in planOptions"
                :key="`selector-${plan}`"
                type="button"
                class="plan-selector-option"
                :class="{ 'is-active': selectedPlan === plan }"
                role="radio"
                :aria-checked="selectedPlan === plan"
                @click="selectedPlan = plan"
              >
                <span class="plan-selector-indicator" aria-hidden="true"></span>
                <span class="plan-selector-label">{{ $t(`home.plans.${plan}`) }}</span>
              </button>
            </div>
          </div>
        </div>

        <div class="coverage-cta">
          <router-link :to="orderLink" class="btn btn-primary shadow-lg btn-lg w-100">
            {{ $t('home.interest_cta') }}
          </router-link>
        </div>
      </aside>
    </div>
  </div>
  <div class="container">
    <h3 class="mt-5">{{$t('home.additional_services.title')}}</h3>
    <div class="row mb-5 mt-4 justify-content-around additional-services">
      <div class="">
        <router-link to="/additional" class="text-decoration-none" style="color: rgb(44, 62, 80);">
          <div class="card text-center">
            <div class="card-img-top text-center">
                <img src="/img/cp/passenger-with-baggage.png">
<!--              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="bi bi-person-plus-fill" viewBox="0 0 16 16">-->
<!--                <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>-->
<!--                <path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>-->
<!--              </svg>-->
            </div>
            <div class="card-body">
              <h3 class="card-title" v-html="$t('home.additional_services.companions.title')"></h3>
            </div>
          </div>
        </router-link>
      </div>
      <div class="">
        <a :href="tripExtensionURL" class="text-decoration-none" style="color: rgb(44, 62, 80);">
          <div class="card text-center">
            <div class="card-img-top text-center">
              <img src="/img/cp/beach-umbrella.png">
            </div>
            <div class="card-body">
              <h3 class="card-title" v-html="$t('home.additional_services.trip_extension.title')"></h3>
            </div>
          </div>
        </a>
      </div>
      <div class="">
        <a :href="tripCancellationURL" class="text-decoration-none" style="color: rgb(44, 62, 80);">
          <div class="card text-center">
            <div class="card-img-top text-center">
              <img src="/img/cp/suitcase.png">
            </div>
            <div class="card-body">
              <h3 class="card-title" v-html="$t('home.additional_services.trip_cancel.title')"></h3>
            </div>
          </div>
        </a>
      </div>
      <div v-if="carTripURL">
        <a :href="carTripURL" class="text-decoration-none" style="color: rgb(44, 62, 80);">
          <div class="card text-center">
            <div class="card-img-top text-center">
              <img src="/img/cp/ground-transportation.png">
            </div>
            <div class="card-body">
              <h3 class="card-title" v-html="$t('home.additional_services.car.title')"></h3>
            </div>
          </div>
        </a>
      </div>
      <div v-if="bikeTripURL">
        <a :href="bikeTripURL" class="text-decoration-none" style="color: rgb(44, 62, 80);">
          <div class="card text-center">
            <div class="card-img-top text-center">
              <img src="/img/cp/bicycle.png">
            </div>
            <div class="card-body">
              <h3 class="card-title" v-html="$t('home.additional_services.bike.title')"></h3>
            </div>
          </div>
        </a>
      </div>
      <div  v-if="isSlovak">
        <a href="#" class="text-decoration-none" style="color: rgb(44, 62, 80);">
          <div class="card text-center">
            <div class="card-img-top text-center">
              <img src="/img/cp/beach%20blue.png">
            </div>
            <div class="card-body">
              <h3 class="card-title" v-html="$t('home.additional_services.short_term')"></h3>
            </div>
          </div>
        </a>
      </div>

      <div v-if="isSlovak">
        <a  href="#" class="text-decoration-none" style="color: rgb(44, 62, 80);">
          <div class="card text-center">
            <div class="card-img-top text-center">
              <img src="/img/cp/national-park.png">
            </div>
            <div class="card-body">
              <h3 class="card-title" v-html="$t('home.additional_services.park')"></h3>
            </div>
          </div>
        </a>
      </div>
      <div v-if="isSlovak">
        <a  target="_blank" :href="$t('home.additional_services.golf_url')" class="text-decoration-none" style="color: rgb(44, 62, 80);">
          <div class="card text-center">
            <div class="card-img-top text-center">
              <img src="/img/cp/golf.png">
            </div>
            <div class="card-body">
              <h3 class="card-title" v-html="$t('home.additional_services.golf')"></h3>
            </div>
          </div>
        </a>
      </div>
      <div v-if="isSlovak">
        <a href="#" class="text-decoration-none" style="color: rgb(44, 62, 80);">
          <div class="card text-center">
            <div class="card-img-top text-center">
              <img src="/img/cp/sail-boat.png">
            </div>
            <div class="card-body">
              <h3 class="card-title" v-html="$t('home.additional_services.ship')"></h3>
            </div>
          </div>
        </a>
      </div>
      <div>
        <a href="/drone" class="text-decoration-none" style="color: rgb(44, 62, 80);">
          <div class="card text-center">
            <div class="card-img-top text-center">
              <img src="/img/cp/drone.png">
            </div>
            <div class="card-body">
              <h3 class="card-title">poistenie<br>dronov</h3>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>

  <section class="faq-section bg-light">
    <div class="container">
      <div class="faq-layout">
        <div class="faq-left">
          <h3>{{ capitalizeFirstChar($t("home.faq_title")) }}</h3>
        </div>
        <div class="faq-right">
          <FAQPart />
        </div>
      </div>
    </div>
  </section>


  <!--  <div class="home">-->
  <!--    <img alt="Vue logo" src="../assets/logo.png">-->
  <!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
  <!--  </div>-->

</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
//import HeaderPart from "@/components/parts/HeaderPart";
import FAQPart from "@/components/accordion/FAQPart";

const PLAN_AMOUNTS = {
  sk: {
    extra: [
      '250 000 €',
      '1 000 €',
      '600 €',
      '80 000 €',
      '15 000 €',
      '1 500 €',
      '1 500 €',
      '1 500 €',
      '5 000 €',
      '800 €',
      '800 €',
      '0 €',
      '16 000 €',
      '200 000 €'
    ],
    plus: [
      '200 000 €',
      '1 000 €',
      '600 €',
      '50 000 €',
      '15 000 €',
      '1 500 €',
      '1 500 €',
      '1 500 €',
      '3 000 €',
      '800 €',
      '800 €',
      '2 000 €',
      '16 000 €',
      '200 000 €'
    ],
    basic: [
      '150 000 €',
      '0 €',
      '500 €',
      '30 000 €',
      '10 000 €',
      '1 000 €',
      '1 000 €',
      '1 000 €',
      '2 000 €',
      '500 €',
      '500 €',
      '0 €',
      '0 €',
      '100 000 €'
    ]
  },
  cz: {
    extra: [
      '6 250 000 Kč',
      '25 000 Kč',
      '15 000 Kč',
      '2 000 000 Kč',
      '375 000 Kč',
      '37 500 Kč',
      '37 500 Kč',
      '37 500 Kč',
      '125 000 Kč',
      '20 000 Kč',
      '20 000 Kč',
      '0 Kč',
      '400 000 Kč',
      '5 000 000 Kč'
    ],
    plus: [
      '5 000 000 Kč',
      '25 000 Kč',
      '15 000 Kč',
      '1 250 000 Kč',
      '375 000 Kč',
      '37 500 Kč',
      '37 500 Kč',
      '37 500 Kč',
      '75 000 Kč',
      '20 000 Kč',
      '20 000 Kč',
      '50 000 Kč',
      '400 000 Kč',
      '5 000 000 Kč'
    ],
    basic: [
      '3 750 000 Kč',
      '0 Kč',
      '12 500 Kč',
      '750 000 Kč',
      '250 000 Kč',
      '25 000 Kč',
      '25 000 Kč',
      '25 000 Kč',
      '50 000 Kč',
      '12 500 Kč',
      '12 500 Kč',
      '0 Kč',
      '0 Kč',
      '2 500 000 Kč'
    ]
  }
}

const INSURED_PERSONS = {
  sk: {
    extra: '1 hlavná osoba + 4 spolucestujúci',
    single: '1 osoba'
  },
  cz: {
    extra: '1 hlavní osoba + 4 spolucestující',
    single: '1 osoba'
  }
}

const ANNUAL_PREMIUM = {
  sk: {
    extra: '99 €',
    plus: '79 €',
    basic: '59 €'
  },
  cz: {
    extra: '2 475 Kč',
    plus: '1 975 Kč',
    basic: '1 475 Kč'
  }
}

export default {
  name: 'HomeView',
  components: {
    FAQPart
  },
  data: function (){
    return {
      selectedPlan: 'extra',
      planOptions: ['extra', 'plus', 'basic'],
      tripExtensionURL: '/trip-extension',
      tripCancellationURL: '#',
      carTripURL: '',
      bikeTripURL: '',
      // Text keys only (no numbers) - amounts are kept in this component.
      planRowKeys: [
        'home.plans.rows.row1.label',
        'home.plans.rows.row2.label',
        'home.plans.rows.row3.label',
        'home.plans.rows.row4.label',
        'home.plans.rows.row5.label',
        'home.plans.rows.row6.label',
        'home.plans.rows.row7.label',
        'home.plans.rows.row8.label',
        'home.plans.rows.row9.label',
        'home.plans.rows.row10.label',
        'home.plans.rows.row11.label',
        'home.plans.rows.row12.label',
        'home.plans.rows.row13.label',
        'home.plans.rows.row14.label'
      ]
    }
  },
  computed: {
    isSlovak: function (){
      return this.$i18n.locale === 'sk';
    },
    activePlanLocaleKey: function () {
      // i18n locale is expected to be 'sk' or 'cz'.
      return this.$i18n.locale === 'cz' ? 'cz' : 'sk';
    },
    planAmounts: function () {
      return PLAN_AMOUNTS[this.activePlanLocaleKey];
    },
    orderLink: function () {
      return {
        path: '/order',
        query: { rozsah: this.selectedPlan }
      };
    }
  },
  methods: {
    capitalizeFirstChar(text) {
      if (!text) return '';
      const locale = this.$i18n?.locale === 'cz' ? 'cs-CZ' : 'sk-SK';
      return text.charAt(0).toLocaleUpperCase(locale) + text.slice(1);
    },
    planColClass(plan) {
      return {
        'plan-col-selected': this.selectedPlan === plan,
        [`plan-tier-col-${plan}`]: true
      };
    },
    insuredTextForPlan(plan) {
      if (plan === 'extra') {
        return INSURED_PERSONS[this.activePlanLocaleKey].extra;
      }
      return INSURED_PERSONS[this.activePlanLocaleKey].single;
    },
    premiumForPlan(plan) {
      return ANNUAL_PREMIUM[this.activePlanLocaleKey][plan];
    }
  },
  mounted() {
    if(this.$i18n.locale === 'sk') {
      this.tripExtensionURL = '/trip-extension';
      this.tripCancellationURL = '/trip-cancellation';
      this.carTripURL = '/car';
      this.bikeTripURL = '/bike';
    }
  }
}
</script>
<style>
img{
  max-width: 100%;

}
strong{
  color: var(--main-color);
}


.hero.has-content:after {
  content: '';
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  opacity: 1;
  z-index: 1;
  background-image: linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.0) 70%);
}
.hero .container{
  position: relative;
  z-index: 2;
}
.hero h2{
  font-size: 2.5rem;
  margin-top: 320px;
  padding-bottom: 15px;
  color: white;
}

.hero.top{
  background-position: right 10% bottom 0%;
}

.hero.bottom{
  background-position: left bottom 60%;
}
.coverage-section{
  margin-bottom: 3rem;
}

.coverage-layout{
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  column-gap: 28px;
  align-items: stretch;
}

.coverage-main{
  grid-column: 1;
  min-width: 0;
}

.coverage-sidebar{
  grid-column: 2;
  display: flex;
  flex-direction: column;
}

.coverage-sidebar-top{
  flex: 1 1 auto;
  min-height: 0;
}

.coverage-sidebar-inner{
  position: sticky;
  top: 90px;
  padding: 1.5rem;
  background: #f8fbff;
  border: 1px solid #dbe7f5;
  border-radius: 12px;
}

.coverage-sidebar-sticky-wrap .coverage-sidebar-inner{
  max-height: calc(100% - 10px);
  overflow-y: auto;
}

.coverage-cta{
  flex-shrink: 0;
  padding-top: 10px;
}

.coverage-sidebar-title{
  margin: 0 0 1rem;
  color: var(--main-color);
  font-size: 1.15rem;
  font-weight: 700;
}

.plan-selector{
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.plan-selector-option{
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.85rem 1rem;
  border: 1px solid #dbe7f5;
  border-radius: 999px;
  background: #fff;
  color: #2c3e50;
  font-weight: 600;
  text-align: left;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.plan-selector-option:hover{
  border-color: var(--main-color);
}

.plan-selector-option.is-active{
  background: #eaf3ff;
  border-color: #b8d9f5;
  color: var(--main-color);
}

.plan-selector-indicator{
  flex: 0 0 22px;
  width: 22px;
  height: 22px;
  border: 2px solid #c5d7ea;
  border-radius: 50%;
  background: #fff;
  position: relative;
}

.plan-selector-option.is-active .plan-selector-indicator{
  border-color: var(--main-color);
  background: var(--main-color);
}

.plan-selector-option.is-active .plan-selector-indicator::after{
  content: '';
  position: absolute;
  left: 6px;
  top: 3px;
  width: 6px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.plan-selector-label{
  flex: 1;
}

.coverage-title{
  color: var(--main-color);
  text-align: left;
  margin: 2.5rem 0;
}

.covering{
  font-size: 0.9em;
}

.covering td,
.covering th{
  padding: 5px 8px;
  vertical-align: middle;
}

.plans-comparison{
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
}

/* Bootstrap `.table` sets dark borders on cells — override for this table */
table.table.plans-comparison > :not(caption) > * > *{
  border-style: solid;
  border-color: transparent;
  border-width: 0;
}

.plans-comparison .plans-section-end td{
  border-bottom: 1px solid #c5d9eb;
}

.plan-tier{
  font-weight: 700;
  color: var(--main-color);
  font-size: 1.05em;
}

.plan-left-header{
  color: var(--main-color);
  font-weight: 700;
  font-size: 1.35em;
  text-align: left;
  background: transparent;
}

.plans-comparison thead th[class*='plan-tier-col-'],
.plans-comparison tbody td[class*='plan-tier-col-']{
  background: #d6eaf8;
}

.plans-comparison thead th.plan-col-selected,
.plans-comparison tbody td.plan-col-selected[class*='plan-tier-col-']{
  background: #9ec5e3;
}

.plans-comparison thead th.plan-col-selected{
  color: var(--main-color);
  font-weight: 700;
}

.plans-comparison .plans-spacer-row td{
  height: 1.75rem;
  padding: 0;
  border: none !important;
  background: transparent !important;
}

.plans-comparison .plans-footer-start > *{
  border-top: 1px solid #c5d9eb !important;
}

.plans-col-label{
  width: 40%;
}

.plans-col-tier{
  width: 20%;
}

.plans-comparison th:not(:first-child),
.plans-comparison td:not(:first-child){
  text-align: center;
}

.plans-comparison td:first-child,
.plans-comparison th:first-child{
  word-break: break-word;
}

.annual-premium-row td{
  font-size: 1.1em;
}

.annual-premium-row td strong{
  font-weight: 400;
}

.annual-premium-row td.plan-col-selected{
  color: var(--main-color);
  font-weight: 700;
}
.additional-services{
  align-items: stretch;

}
.additional-services > div{
  margin-top: 20px;
  width: 20%;
  flex: 1;
  max-width: 300px;
  min-width: 250px;
}

.additional-services h3{
  color: rgb(0, 0, 0, .7);
  font-size: 1.4em;
}

.additional-services .card{
  flex: 1;
  margin-top: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.additional-services .card-img-top{
  margin-top: 20px;
}

.additional-services .card-img-top img{
  max-width: 80px;
}

.additional-services .card-body{
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.additional-services .card-title{
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
}

.faq-section{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
  background-color: var(--bs-light, #f8f9fa) !important;
}

.faq-section .faq-left,
.faq-section .faq-right,
.faq-section .accordion,
.faq-section .accordion-item,
.faq-section .accordion-header,
.faq-section .accordion-button,
.faq-section .accordion-collapse,
.faq-section .accordion-body{
  background-color: var(--bs-light, #f8f9fa);
}

.faq-layout{
  display: flex;
  align-items: flex-start;
  gap: 72px;
}

.faq-left{
  flex: 0 0 260px;
  position: sticky;
  top: 90px;
}

.faq-left h3{
  margin: 0;
  font-size: 1.6em;
}

.faq-right{
  flex: 1;
  min-width: 0;
}

@media (max-width: 992px){
  .coverage-layout{
    grid-template-columns: 1fr;
  }

  .coverage-main,
  .coverage-sidebar{
    grid-column: 1;
    width: 100%;
  }

  .coverage-cta{
    margin-top: 1rem;
  }

  .coverage-sidebar-top{
    flex: 0 1 auto;
  }

  .coverage-sidebar-sticky-wrap .coverage-sidebar-inner{
    max-height: none;
    overflow-y: visible;
  }

  .coverage-sidebar-inner{
    position: relative;
    top: auto;
  }

  .faq-layout{
    flex-direction: column;
    gap: 20px;
  }
  .faq-left{
    position: relative;
    top: auto;
    flex: 0 0 auto;
  }
}

</style>
